import type { FilterInput } from '../constants';

export type ParsedI6Lookup = {
  filters: FilterInput[];
  logicalOperator: 'And' | 'Or';
};

/**
 * Parse an `i6LookupString` produced by `RPT.p_Lookups_Insert` into filter rows
 * and the group's logical combiner.
 *
 * Example:
 *   filterGroups: { filters: [{ field: SOCIETY_MEMBER_FIELD15, operator: CONTAINS, value: "2" }, ...] logicalOperator: OR }
 */
export function parseI6LookupString(raw?: string): ParsedI6Lookup {
  if (!raw) {
    return { filters: [], logicalOperator: 'And' };
  }

  const filters: FilterInput[] = [];
  const re =
    /\{\s*field:\s*(\w+)\s*,\s*operator:\s*(\w+)(?:\s*,\s*value:\s*"([^"]*)")?\s*\}/g;
  let match: RegExpExecArray | null;
  while ((match = re.exec(raw)) !== null) {
    filters.push({
      field: match[1]!,
      operator: match[2]!,
      value: match[3] ?? '',
    });
  }

  const opMatch = raw.match(/logicalOperator:\s*(AND|OR)\b/i);
  const logicalOperator = opMatch?.[1]?.toUpperCase() === 'OR' ? 'Or' : 'And';

  return { filters, logicalOperator };
}
